import * as React from "react";

import { cn } from "@/lib/utils";

export interface FormProps extends React.ComponentPropsWithoutRef<"form"> {
  isSubmitting?: boolean;
}

const Form = React.forwardRef<HTMLFormElement, FormProps>(
  (
    {
      "aria-busy": ariaBusy,
      children,
      className,
      isSubmitting = false,
      noValidate = true,
      onSubmit,
      ...props
    },
    ref,
  ) => {
    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
      if (isSubmitting) {
        event.preventDefault();
        return;
      }

      onSubmit?.(event);
    };

    return (
      <form
        ref={ref}
        noValidate={noValidate}
        aria-busy={ariaBusy ?? (isSubmitting || undefined)}
        className={cn(className)}
        onSubmit={handleSubmit}
        {...props}
      >
        {children}
      </form>
    );
  },
);
Form.displayName = "Form";

export { Form };
